<template>
    <div style="display: flex; flex-wrap: wrap; justify-content: center">
        <div class="kb-chip"
             :key="i"
             style="cursor: default"
             v-for="(item, i) in suggestion"
             v-html="parseText(item)">
        </div>

        <div class="kb-helper-link-out-suggestion"
             v-if="linkOutSuggestion">
            {{linkOutSuggestion.destinationName}}
        </div>
    </div>
</template>

<script>
import { EmojiConvertor } from 'emoji-js'

export default {
  computed: {
    linkOutSuggestion () {
      if (!this.payload) return ''

      return ''

      // const linkOutSuggestion = this.helper.find(element => element.message === 'linkOutSuggestion')
      //
      // return linkOutSuggestion ? linkOutSuggestion.linkOutSuggestion : null
    },
    suggestion () {
      return this.payload.suggestion
    }
  },
  methods: {
    parseText (text) {
      const emoji = new EmojiConvertor()
      emoji.img_sets.apple.path = 'https://unicodey.com/js-emoji/build/emoji-data/img-apple-64/'
      emoji.replace_mode = 'img'
      emoji.supports_css = false

      let originalText = text
      originalText = originalText.replace(/</igm, '&lt;').replace(/>/igm, '&gt;')
      originalText = emoji.replace_unified(originalText)
      return originalText
    },
    sendSuggestion (suggestion) {
      this.$store.dispatch('sendMessage', { text: suggestion })
    }
  },
  props: ['payload']
}
</script>

<style>
    @import "../../../styles/Conversations/KBHelper.scss";
</style>
